import type { CiReport } from './ci-report';

// CI - Final Master, Field Dictionary!J35:
// https://docs.google.com/spreadsheets/d/1V3td4narwhqS0onFbKe51EjplM8AwAHgr12XFwl8Kdg/edit
// These are display classifications only; backend valuations remain unchanged.
export function negotiationPotential(asking: number | undefined, benchmark: number | undefined): string | undefined {
  if (asking == null || benchmark == null || !Number.isFinite(asking) || !Number.isFinite(benchmark)
    || asking < 0 || benchmark <= 0) return undefined;
  if (asking > benchmark * 1.07) return 'High';
  if (asking > benchmark) return 'Moderate';
  return 'Low';
}

export function ciMoneyNumber(value: unknown): number | undefined {
  if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
  if (typeof value !== 'string') return undefined;
  const match = value.trim().replace(/[₹,\s]/g, '').match(/^([-+]?\d+(?:\.\d+)?)(Cr|Crore|L|Lac|Lakh)?$/i);
  if (!match) return undefined;
  const exponent = /^cr/i.test(match[2] ?? '') ? 7 : /^l/i.test(match[2] ?? '') ? 5 : 0;
  const number = Number(`${match[1]}e${exponent}`);
  return Number.isFinite(number) ? number : undefined;
}

// Formula & Rules!C4 defines a percentage, not High/Moderate/Low yield bands.
export function rentalYieldIndicator(report: CiReport | null): string {
  if (report?.rentalRating) return report.rentalRating;
  const yieldValue = report?.valuation.find(metric => metric.label === 'Rental Yield')?.value;
  return yieldValue && !['not available', 'n/a', '—', '-'].includes(yieldValue.trim().toLowerCase())
    ? yieldValue : 'Not available';
}
